import type { CSSProperties, ReactElement, ReactNode } from 'react';
import { type XYCoord, useDragLayer } from 'react-dnd';

const dragLayerStyles: CSSProperties = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
};

function getDragLayerStyles(
  initialOffset: XYCoord | null,
  currentOffset: XYCoord | null,
) {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }

  const transform = `translate(${currentOffset.x}px, ${currentOffset.y}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
}

export interface PreviewDragLayerProps<TDragItem> {
  itemType: string;
  children: (item: TDragItem) => ReactNode;
}

export const PreviewDragLayer = <TDragItem,>(
  props: PreviewDragLayerProps<TDragItem>,
): ReactElement | null => {
  const { itemType, isDragging, item, initialOffset, currentOffset } =
    useDragLayer((monitor) => ({
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      initialOffset: monitor.getInitialSourceClientOffset(),
      currentOffset: monitor.getSourceClientOffset(),
      isDragging: monitor.isDragging(),
    }));

  if (!isDragging || props.itemType !== itemType) {
    return null;
  }
  return (
    <div style={dragLayerStyles}>
      <div style={getDragLayerStyles(initialOffset, currentOffset)}>
        {props.children(item)}
      </div>
    </div>
  );
};
